module.exports = __webpack_public_path__ + "static/media/maintenance_schedule.b72b0e08.svg";